import Header from "./Shared/Header";
import Footer from "./Shared/Footer";
import '../ComponentCss/PrivacyPolicy.css';
import Breadcrumb from "./Breadcrumb";

const PrivacyPolicy = () => {
    return (
        <>
            <Header />
            <section className="contact-banner-sec">
                <div className="container-fluid">
                    <div className="page-header">
                        <h1>Privacy Policy</h1>
                    </div>
                    <Breadcrumb />
                </div>
            </section>
            <section>
                <div className="container">
                    <div className="privacy_policy_wepper">
                        {/* Section 1 */}
                        <div className="privacy_policy_inner">
                            <h2>Privacy Policy for MU Gems Jewelry </h2>
                            <p>
                                At MU Gems Jewelry ("we," "our," "us"), we respect your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard your information when you visit our website, purchase our products, or interact with us.
                            </p>
                        </div>

                        {/* Section 2 */}
                        <div className="privacy_policy_inner">
                            <h2>Information We Collect</h2>
                            <p>
                                Personal Information: Name, email address, phone number, billing/shipping address, payment information, and any other information you provide when purchasing our jewelry or creating an account.
                            </p>
                            <p>
                                Non-Personal Information: Browser type, IP address, device information, and website usage data (through cookies and similar technologies).
                            </p>
                        </div>

                        {/* Section 3 */}
                        <div className="privacy_policy_inner">
                            <h2>How We Use Your Information</h2>
                            <ul>
                                <li>To process transactions and deliver products you purchase.</li>
                                <li>To communicate with you about your orders, offers, or updates.</li>
                                <li>To improve our website, services, and user experience.</li>
                            </ul>
                        </div>

                        {/* Section 4 */}
                        <div className="privacy_policy_inner">
                            <h2>Sharing Your Information</h2>
                            <p>
                                Service Providers: Trusted third parties who assist us with payment processing, delivery, or website operations.

                            </p>
                            <p>Legal Compliance: When required by law or to protect our rights, safety, or property.</p>
                            <ul>
                                <li>
                                    Informing and advising employees and third parties about data
                                    protection regulations.
                                </li>
                                <li>Overseeing Data Protection Impact Assessments (DPIAs).</li>
                                <li>
                                    Acting as a point of contact for Data Protection Authorities
                                    (DPAs).
                                </li>
                                <li>
                                    Ensuring compliance with policies, practices, and third-party
                                    agreements regarding personal data.
                                </li>
                            </ul>
                        </div>

                        {/* Section 5 */}

                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}


export default PrivacyPolicy;
